var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoSymbol = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "noSymbol")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26,7.08A18.92,18.92,0,1,1,7.08,26,18.94,18.94,0,0,1,26,7.08M26,0A26,26,0,1,0,52,26,26,26,0,0,0,26,0Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.13,
  y: 22.46,
  width: 51.74,
  height: 7.08,
  transform: "translate(-10.77 26) rotate(-45)",
  fill: "currentColor"
})))));
export default SvgNoSymbol;